import { render, staticRenderFns } from "./reviewTopicDetail.vue?vue&type=template&id=cb527270&scoped=true&"
import script from "./reviewTopicDetail.vue?vue&type=script&lang=js&"
export * from "./reviewTopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./reviewTopicDetail.vue?vue&type=style&index=0&id=cb527270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb527270",
  null
  
)

export default component.exports